import React from 'react';
import { T } from '../../utils/theme';
import { Home, List, FileText, Wallet, MoreHorizontal, DollarSign, Calendar } from 'lucide-react';

const TAB_ICONS = {
  home: Home, dashboard: Home, fila: List, comandas: FileText,
  saques: Wallet, 'gestao-saques': Wallet, mais: MoreHorizontal,
  comissoes: DollarSign, agendamentos: Calendar,
};

const FloatingTabBar = ({ items, activeKey, onSelect }) => (
  <div className="floating-tab-bar md:hidden">
    <div className="floating-tab-bar-inner">
      {items.map(item => {
        const active = item.key === activeKey;
        const IconComp = TAB_ICONS[item.key] || Home;
        return (
          <button key={item.key} onClick={() => onSelect(item.key)}
            className={`tab-btn ${active ? 'active' : ''}`}>
            <IconComp size={22} strokeWidth={active ? 2.2 : 1.7} />
          </button>
        );
      })}
    </div>
  </div>
);

export default FloatingTabBar;
